import { GUDHUB_SETTINGS } from './../../config.js';

angular.module('userSettingsMod')

.controller('integrationsCtrl', ['$scope', async ($scope) => {

	const token = await gudhub.getToken();

	const response = await fetch(`${GUDHUB_SETTINGS.node_services_api_path}/integrations?token=${encodeURIComponent(token)}`);
	const integrations = await response.json();

	$scope.integrations = integrations.data;

	$scope.$digest();

}]);
